




































import { Vue, Component, Inject } from "vue-property-decorator";

// Enums/Data
import { ProductTypes } from "@/data/enums/products";
import { ListDisplayMode } from "@/data/constants";

// Types
import { IDomainsProviderMethods } from "@/modules/web_hosting/models/domains";

@Component({
  components: {
    "tlds-provider": () =>
      import("@/modules/web_hosting/components/domains/tldsProvider.vue"),
    "products-listing": () =>
      import(
        "@/components/app/admin/catalogue/products/listing/productsListing.vue"
      )
  }
})
export default class DomainsTldsView extends Vue {
  // Inject

  @Inject({ from: "domainsProviderMethods" })
  public $domainsMethods!: IDomainsProviderMethods;

  // Variables

  public availableModes = [ListDisplayMode.TABLE, ListDisplayMode.GRID];
  public productTypes = [
    ProductTypes.SINGLE_PRODUCT,
    ProductTypes.PRODUCT_BUNDLE
  ];
}
